/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Library_TitleInputs */

const en_library_title = /** @type {(inputs: Library_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Library`)
};

const pl_library_title = /** @type {(inputs: Library_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteka`)
};

/**
* | output |
* | --- |
* | "Library" |
*
* @param {Library_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const library_title = /** @type {((inputs?: Library_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Library_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_library_title(inputs)
	return en_library_title(inputs)
});